import { getModule } from "vuex-module-decorators";
import store from "@/store";
import Http from "./http";
import Customizer from "./customizer";
import CurrentUser from "./currentUser";
import Routing from "./routing";
import Onboarding from "./onboarding";

export const httpStore: Http = getModule(Http, store);
export const customizationStore: Customizer = getModule(Customizer, store);
export const currentUserStore: CurrentUser = getModule(CurrentUser, store);
export const routingStore: Routing = getModule(Routing, store);
export const onboardingStore: Onboarding = getModule(Onboarding, store);
